import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {Race} from './race';
import {RacesService} from '../races.service';
import {Results} from '../../../core/results';
declare var $: any;
@Directive({
  selector: '[appRace]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RaceDirective),
    multi: true
  }]
})
export class RaceDirective implements ControlValueAccessor, OnInit {

  @Input() private race: Race;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: RacesService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Race',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<Race>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.race = JSON.parse(e.params.data.id);
      that.propagateChange(that.race);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.race = null;
      that.propagateChange(that.race);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(race: Race): void {

    this.race = race;
    this.propagateChange(this.race);
    const that = this;
    if (this.race !== undefined && this.race !== null) {
      const option = new Option(race.name, JSON.stringify(race), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.race;
  }

  set value(v: any) {
    if (v !== this.race) {
      this.race = v;
      this.propagateChange(v);
    }
  }

}
